module.exports = __webpack_public_path__ + "static/media/social3.8c54ca51.png";